import { useEffect } from 'react';
import { globalIsDirtyVar } from './variables';

export const useGlobalIsDirty = isDirty => {
  useEffect(() => {
    globalIsDirtyVar(isDirty);
    return () => {
      globalIsDirtyVar(false);
    };
  }, [isDirty]);
};
